<template>
  <b-container>
    <b-card
      title="Set New Password"
      class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4"
    >
      <template v-if="status === 'successful'">
        <p class="card-text">
          비밀번호가 설정되었습니다. 이제 로그인하세요.
        </p>
        <p class="card-text">
          Your password has been set. You may go ahead and log in now.
        </p>
      </template>
      <template v-else-if="status === 'expired'">
        <p class="card-text">
          비밀번호 초기화 링크가 이미 사용되어 올바르지 않습니다. 비밀번호
          초기화를 다시 해주세요.
        </p>
        <p class="card-text">
          The password reset link was invalid, possibly because it has already
          been used. Please request a new password reset.
        </p>
      </template>
      <b-form @submit.prevent="update" v-else>
        <b-form-group
          label="New Password"
          description="Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 lowercase letter and 1 digit."
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="password"
            :state="feedback.password ? !feedback.password : null"
            required
          ></b-form-input>
          <b-form-invalid-feedback
            :key="index"
            v-for="(f, index) in feedback.password"
            v-if="feedback.password"
          >
            {{ f }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="New Password Confirmation"
          label-class="font-weight-bold"
        >
          <b-form-input
            type="password"
            v-model="passwordConfirmation"
            :state="password ? passwordConfirmation === password : null"
            required
            ref="passwordConfirmation"
          ></b-form-input>
          <b-form-invalid-feedback>
            비밀번호가 일치하지 않습니다.
          </b-form-invalid-feedback>
        </b-form-group>
        <div class="submit-button-group">
          <b-button
            type="submit"
            variant="primary"
            :disabled="this.status === 'loading'"
            >Set Password</b-button
          >
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import Vue from "vue";
import { User } from "../models";

export default Vue.component("reset", {
  data() {
    return {
      feedback: {},
      password: "",
      passwordConfirmation: "",
      status: null
    };
  },
  methods: {
    async update() {
      if (this.password !== this.passwordConfirmation) {
        this.$refs.passwordConfirmation.focus();
        return;
      }

      this.status = "loading";
      try {
        await new User().reset({
          uidb64: this.$route.params.uidb64,
          token: this.$route.params.token,
          password: this.password
        });

        this.status = "successful";
      } catch ({ response }) {
        if (response.status === 400) {
          this.feedback = response.data;
          if (this.feedback.token) {
            this.status = "expired";
          }
        }
      }
    }
  }
});
</script>
